import React from 'react';

import { TextBox, Wrapper } from './styles';

export interface Props {
  name: string;
  value: string;
  placeHolder?: string;
  maxLength?: number;
  resizableVertically?: boolean;
  scrollable?: boolean;
  handleChange: (val: any) => void;
}

const Textarea: React.FC<Props> = ({
  name,
  placeHolder = '',
  maxLength,
  resizableVertically = false,
  scrollable = false,
  value,
  handleChange,
  children,
}) => {
  return (
    <Wrapper>
      <TextBox
        name={name}
        value={value}
        maxLength={maxLength}
        placeholder={placeHolder}
        resizable={resizableVertically}
        scrollable={scrollable}
        onChange={handleChange}></TextBox>
      {children}
    </Wrapper>
  );
};

export default Textarea;
